import { makeDefaultApi } from './request';
import { I18nText } from '../i18n_text';
import { DriverData } from './drivers';

export interface TraitCategoryData {
  id?: string;
  name_json: I18nText;
  driver: DriverData | null;
  code?: string;
}

export interface ListParams {
  ids?: string[];
  client_type_ids?: string[];
  driver_ids?: string[];
  /** The React table's filter model, serialised, and its sort keys. */
  filter?: string;
  sort?: string[];
}

export const { list, retrieve, save, remove } = makeDefaultApi<TraitCategoryData, ListParams>(
  'trait_categories'
);
